import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { for: "PaytDoctNbr" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-arrow-down-fill" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_12 = { class: "col-md-6 form-group" }
const _hoisted_13 = { for: "PaytType" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { value: 0 }
const _hoisted_16 = { value: 1 }
const _hoisted_17 = { value: 2 }
const _hoisted_18 = { class: "col-md-6 form-group" }
const _hoisted_19 = { for: "DateSent" }
const _hoisted_20 = { for: "PaytAmt" }
const _hoisted_21 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = { class: "d-flex justify-content-end" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_numeric_fld_input = _resolveComponent("numeric-fld-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-none': !_ctx.visible}, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.PaytDoctNbr.$error}])
            }, [
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.language.doct_nbr) + "  ", 1),
                (_ctx.dataRecord.IdPurchasePayment == 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:;",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateReceiptNbr && _ctx.generateReceiptNbr(...args)))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "PaytDoctNbr",
                class: "form-control capletter",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.PaytDoctNbr) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchasePayment != 0,
                placeholder: '(' + _ctx.language.doct_nbr.toLowerCase() + ')',
                maxlength: "15",
                autocomplete: "off",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_10), [
                [_vModelText, _ctx.dataRecord.PaytDoctNbr]
              ]),
              (_ctx.v$.dataRecord.PaytDoctNbr.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.v$.dataRecord.PaytDoctNbr.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.language.type), 1),
              _withDirectives(_createElementVNode("select", {
                id: "PaytDoctNbr",
                class: "form-control-sel",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.PaytType) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchasePayment != 0
              }, [
                _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.language.cash_payt), 1),
                _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.language.mobile_money), 1),
                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.language.other), 1)
              ], 8, _hoisted_14), [
                [_vModelSelect, _ctx.dataRecord.PaytType]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.language.oper_date), 1),
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.dataRecord.PaytDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.PaytDate) = $event)),
                format: "dd/MM/yyyy",
                cancelText: _ctx.language.cancel,
                selectText: _ctx.language.select,
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchasePayment != 0
              }, null, 8, ["modelValue", "cancelText", "selectText", "disabled"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.PaytAmt.$error}])
            }, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.language.payt_amt), 1),
              _createVNode(_component_numeric_fld_input, {
                id: "PaytAmt",
                modelValue: _ctx.dataRecord.PaytAmt,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.PaytAmt) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchasePayment != 0,
                placeholder: '(' + _ctx.language.payt_amt.toLowerCase() + ')',
                isFloatFormat: true,
                maxlength: 15
              }, null, 8, ["modelValue", "disabled", "placeholder"]),
              (_ctx.v$.dataRecord.PaytAmt.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.v$.dataRecord.PaytAmt.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_24),
            (_ctx.dataRecord.IdPurchasePayment == 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
                  disabled: _ctx.v$.$invalid || _ctx.isSavingRecord
                }, [
                  (_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-save']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
                ], 8, _hoisted_25))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}